/**
 * @generated SignedSource<<36ba6bb6cf701e13606522bf30e33def>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatChannelMessageFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMessageOptionsFragment">;
  readonly " $fragmentType": "ChatChannelMessageFragment";
};
export type ChatChannelMessageFragment$key = {
  readonly " $data"?: ChatChannelMessageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ChatChannelMessageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ChatChannelMessageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ChatChannelMessageOptionsFragment"
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};

(node as any).hash = "eb98a28c6ab0d6da23c8e6f9b7601d40";

export default node;
